export default {"src":"https://gfiber.com/support/_next/static/media/warning.f36270b8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};